module.exports = __webpack_public_path__ + "media/images/mailer/icon_email-ed5d2a37fa765e4c5fec080a82b0a783.png";